import { NgClass } from '@angular/common';
import { Component, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { ProductCategoryChecker } from '../product-category-checker/product-category-checker';
import { ProductColorPicker } from '../product-color-picker/product-color-picker';
import { ProductSizeChecker } from '../product-size-checker/product-size-checker';
import { ProductTagChecker } from '../product-tag-checker/product-tag-checker';
export interface ProductFilters {
  sizes: string[];
  color: string;
  category_ids: number[];
  tags: string[];
}
@Component({
  selector: 'app-product-filters-panel',
  imports: [
    MatExpansionModule,
    ProductSizeChecker,
    FormsModule,
    ProductColorPicker,
    ProductCategoryChecker,
    ProductTagChecker,
    NgClass,
  ],
  templateUrl: './product-filters-panel.html',
  styleUrl: './product-filters-panel.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFiltersPanel),
      multi: true,
    },
  ],
})
export class ProductFiltersPanel implements ControlValueAccessor {
  value: ProductFilters = {
    sizes: [],
    color: '',
    category_ids: [],
    tags: []
  };

  onValueChanged() {
    this.onChange(this.value);
  }

  onChange: (value: ProductFilters) => void = () => { };
  onTouched: () => void = () => { };
  writeValue(value?: ProductFilters): void {
    this.value = value || {
      sizes: [],
      color: '',
      category_ids: [],
      tags: [],
    };
  }

  registerOnChange(fn: (value: ProductFilters) => void): void {
    this.onChange = fn; // 注册外部的变更回调
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn; // 注册外部的触摸回调
  }

  disabled: boolean = false;
  // 可选：禁用组件
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
